import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getFunctions, Functions } from 'firebase/functions';

let app: FirebaseApp;
let auth: Auth;
let db: Firestore;
let storage: FirebaseStorage;
let functions: Functions;

export const initializeFirebase = async () => {
  if (app) return { app, auth, db, storage, functions };

  try {
    // 開発環境の場合、環境変数から読み込み
    if (import.meta.env.DEV) {
      const firebaseConfig = {
        apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
        authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
        projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
        storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
        appId: import.meta.env.VITE_FIREBASE_APP_ID,
      };
  
      app = initializeApp(firebaseConfig);
      auth = getAuth(app);
      db = getFirestore(app);
      storage = getStorage(app);
      functions = getFunctions(app);
  
      console.log('Firebase initialized from environment variables');
      return { app, auth, db, storage, functions };
    }
  
    // 本番環境（Firebase Hosting）の場合、/__/firebase/init.jsonから設定を取得
    const response = await fetch('/__/firebase/init.json');
    const firebaseConfig = await response.json();
    
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    storage = getStorage(app);
    functions = getFunctions(app);
  
    console.log('Firebase initialized successfully');
    return { app, auth, db, storage, functions };
  } catch (error) {
    console.error('Firebase initialization failed:', error);
    throw new Error('Failed to initialize Firebase');
  }  
};

export const getFirebaseServices = () => {
  if (!app) {
    throw new Error('Firebase has not been initialized. Call initializeFirebase() first.');
  }
  return { app, auth, db, storage, functions };
};

export { auth, db, storage, functions };
